import Button from "../components/Button";
import VerificationTooltip from "./MobileVerificationTooltip";
import Spinner from "../components/Spinner";

const UinRequestsDetails = ({
  row,
  handleButtonClick,
  mobileVerificationInfo,
  handleMobileVerification,
  loader,
}: {
  row: any;
  handleButtonClick?: any;
  mobileVerificationInfo?: any;
  handleMobileVerification?: (mobileNumber: number | string, reqId: number | string) => void;
  loader: boolean;
}) => {
  const details = row?.original || row?.row?.original;

  return (
    <section className="px-5 pb-5 border border-[#ccc] border-t-0 rounded-b-lg">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-[#f7f7f7] text-[#616161] font-semibold text-sm">
            <th className="p-2 border border-[#E3E3E3]" />
            <th className="p-2 border border-[#E3E3E3]">As per Company</th>
            <th className="p-2 border border-[#E3E3E3]">As per Medvol</th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7]">Counter Code</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.counter_code || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">
              <a href={`/masters/counters/details/?id=${details?.counter?.counter_id}`} target="_blank">
                {details?.counter_code} - {details?.counter?.pharmacy_name}
              </a>
            </td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7]">Counter name</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.ass_counter_name || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.ass_counter_name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7] ">City</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.uin_city || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.counter?.city_name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7] ">District</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.uin_district || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.counter?.district_name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7]">State</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.uin_state}</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.counter?.state_name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7]">Mobile Number</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.ass_contact_number || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">
              <div className="flex align-center gap-2">
                <span>{details?.ass_contact_number || "-"}</span>
                {details?.ass_contact_number
                  ? (() => {
                      const verificationInfo = mobileVerificationInfo?.[details?.indph_uln_validation];
                      const verificationData = verificationInfo?.verificationData;

                      if (!verificationInfo) return null;

                      return (
                        <div>
                          {verificationInfo.isVerifyReq ? (
                            <Button
                              onClick={() => handleMobileVerification?.(details?.ass_contact_number, details?.indph_uln_validation)}
                              disabled={verificationInfo?.loading}
                              className="bg-transparent border-none p-0 m-0 text-blue-600 font-inherit cursor-pointer"
                            >
                              {verificationInfo?.loading ? <Spinner size="small" /> : "Verify"}
                            </Button>
                          ) : verificationData ? (
                            <VerificationTooltip
                              status={
                                verificationData?.name && !verificationData?.rejected_remarks
                                  ? "success"
                                  : !verificationData?.name && verificationData?.rejected_remarks
                                    ? "failure"
                                    : "unverified"
                              }
                              verificationData={verificationData}
                            />
                          ) : null}
                        </div>
                      );
                    })()
                  : null}
              </div>
            </td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7]">UIN</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.uin_code || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.uin_code}</td>
          </tr>
          <tr className="bg-white text-[#303030] font-[450] text-sm">
            <td className="p-3 border border-[#E3E3E3] bg-[#f7f7f7]">Alternate UIN</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.alternate_uin_code || "-"}</td>
            <td className="p-3 border border-[#E3E3E3]">{details?.alternate_uin_code}</td>
          </tr>
        </tbody>
      </table>
      <footer className="mt-5 flex items-center justify-end gap-3">
        <Button onClick={() => handleButtonClick(details)} className="text-[#E3E3E3] bg-[#8051FF]" isLoading={loader} loaderSize="small">
          Verify UIN
        </Button>
      </footer>
    </section>
  );
};

export default UinRequestsDetails;
